/* tslint:disable */
/* eslint-disable */
/**
 * comici-plus-api
 * # Comici Plus API v1  コンテンツプロバイダーがコンテンツの配信サイトを作成するために利用するAPIを提供します。 
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { UserMissionItemModel } from './UserMissionItemModel';
import {
    UserMissionItemModelFromJSON,
    UserMissionItemModelFromJSONTyped,
    UserMissionItemModelToJSON,
} from './UserMissionItemModel';

/**
 * ガチャ関連のAPIにおいてフロントに返却するレスポンスモデル。
 * `ガチャ情報取得` 及び `ガチャを引く` APIでそれぞれレスポンスモデルとして使用されます。
 * @export
 * @interface GachaModel
 */
export interface GachaModel {
    /**
     * 情報取得の場合 : 現在引けるかどうかを返却 (true or false)
     * ガチャを引いた場合 : 再度引けるかどうかを返却 (true or false)
     * @type {boolean}
     * @memberof GachaModel
     */
    canRollGacha?: boolean;
    /**
     * 当日中に引いたガチャの回数
     * @type {number}
     * @memberof GachaModel
     */
    gachaTimes?: number;
    /**
     * ガチャ結果を返却する
     * 情報取得の場合 : 当日初回の場合は null, 2回目以降の場合は前回の結果
     * ガチャを引いた場合 : 結果枚数
     * @type {number}
     * @memberof GachaModel
     */
    gachaBonusResult?: number;
    /**
     * ガチャを引けない理由
     * * maxAttempt: "1日の上限回数(2回)に達している"
     * * noShared: "Xでシェアしていない"
     * * usedRewardTicket: "1回目のガチャで得たチケットが利用済みである"
     * ガチャが引ける場合は null がセットされます
     * @type {string}
     * @memberof GachaModel
     */
    reasonNoRollGacha?: GachaModelReasonNoRollGachaEnum;
    /**
     * 達成したミッションの情報
     * 情報取得の場合 : null
     * ガチャを引くの場合 : ガチャを引くミッションを達成した場合は達成ミッション情報, 2回目以降はnull
     * @type {Array<UserMissionItemModel>}
     * @memberof GachaModel
     */
    achievedMissionList?: Array<UserMissionItemModel>;
}


/**
 * @export
 */
export const GachaModelReasonNoRollGachaEnum = {
    MAX_ATTEMPT: 'MAX_ATTEMPT',
    NO_SHARED: 'NO_SHARED',
    USED_REWARD_TICKET: 'USED_REWARD_TICKET'
} as const;
export type GachaModelReasonNoRollGachaEnum = typeof GachaModelReasonNoRollGachaEnum[keyof typeof GachaModelReasonNoRollGachaEnum];


/**
 * Check if a given object implements the GachaModel interface.
 */
export function instanceOfGachaModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GachaModelFromJSON(json: any): GachaModel {
    return GachaModelFromJSONTyped(json, false);
}

export function GachaModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): GachaModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'canRollGacha': !exists(json, 'canRollGacha') ? undefined : json['canRollGacha'],
        'gachaTimes': !exists(json, 'gachaTimes') ? undefined : json['gachaTimes'],
        'gachaBonusResult': !exists(json, 'gachaBonusResult') ? undefined : json['gachaBonusResult'],
        'reasonNoRollGacha': !exists(json, 'reasonNoRollGacha') ? undefined : json['reasonNoRollGacha'],
        'achievedMissionList': !exists(json, 'achievedMissionList') ? undefined : ((json['achievedMissionList'] as Array<any>).map(UserMissionItemModelFromJSON)),
    };
}

export function GachaModelToJSON(value?: GachaModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'canRollGacha': value.canRollGacha,
        'gachaTimes': value.gachaTimes,
        'gachaBonusResult': value.gachaBonusResult,
        'reasonNoRollGacha': value.reasonNoRollGacha,
        'achievedMissionList': value.achievedMissionList === undefined ? undefined : ((value.achievedMissionList as Array<any>).map(UserMissionItemModelToJSON)),
    };
}

